import { NoValue } from '@tribeauto/ngx-mobilite-material';

export const formatLocaleDate = (date: Date | NoValue, locale = 'default'): string | null => {
  return date ? new Date(date).toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }) : null;
};

export const formatLocaleDateMonthYear = (date: Date | NoValue, locale = 'default'): string | null => {
  return date ? new Date(date).toLocaleDateString(locale, { month: '2-digit', year: 'numeric' }) : null;
};

export const formatLocaleDateDayMonthYearHourMinute = (date: Date | NoValue, locale = 'default'): string | null => {
  return date ? new Date(date).toLocaleDateString(locale, { hour: '2-digit', minute: '2-digit' }) : null;
};

export const formatDateToSecond = (date: Date): Date => {
  date.setSeconds(0);
  return date;
};
